import { Card, CardProps } from '@/components/layout/Card/Card';

export type DataTableCardProps = Partial<CardProps>;

export function DataTableCard({
  children,
  sx,
  variant = 'transparent',
  ...cardProps
}: DataTableCardProps) {
  return (
    <Card
      variant={variant}
      sx={{ height: '100%', flexGrow: 1, ...sx }}
      {...cardProps}
    >
      {children}
    </Card>
  );
}
